module.exports = __webpack_public_path__ + "static/media/expired-lease-icon.7de1957d.svg";